import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get, isUndefined } from 'lodash';
import { loadNotes } from 'actions';
import { getLoaders, resolveNotesPlayerId, resolveNotesQuestionnaireId, resolveNotesSurvey } from 'selectors';
import { LoadingSpinner } from 'components/helpers/LoadingSpinner';
import QuestionNotesContainer from './QuestionNotesContainer';


class QuestionNotesModal extends React.Component {
  static propTypes = {
    asqQuestionId: PropTypes.number.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isData: PropTypes.object,
    hasNotes: PropTypes.bool.isRequired,
    qNumber: PropTypes.number.isRequired,
    params: PropTypes.object.isRequired,
    survey: PropTypes.object,
    loadNotes: PropTypes.func.isRequired,
  }

  componentDidMount() {
    const { params, asqQuestionId } = this.props;
    if (!params.playerQuestionnaireId) return;
    this.props.loadNotes(params, {source: 'init'}, {asq_question_id: asqQuestionId});
  }

  render() {
    const { hasNotes, isData, isLoading, asqQuestionId, qNumber, params, survey } = this.props;
    if (hasNotes && (isLoading || isUndefined(isData))) {
      return (
        <div className='column u-margin-top--base u-margin-bottom--base'>
          <LoadingSpinner />
        </div>
      );
    }
    return (
      <div>
        <QuestionNotesContainer asqQuestionId={asqQuestionId} qNumber={qNumber} params={params} survey={survey} />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    asqQuestionId: ownProps.asqQuestionId,
    isLoading: getLoaders(state, ['WEBNOTES']),
    isData: get(state.modal.meta, `entities.questions[${ownProps.asqQuestionId}]`),
    hasNotes: ownProps.hasNotes,
    survey: resolveNotesSurvey(state, ownProps),
    params: {
      asqQuestionId: ownProps.asqQuestionId,
      playerId: resolveNotesPlayerId(state, ownProps),
      playerQuestionnaireId: resolveNotesQuestionnaireId(state, ownProps),
    },
    qNumber: ownProps.qNumber,
  }
}

export default connect(mapStateToProps, { loadNotes })(QuestionNotesModal);
